module.exports = __webpack_public_path__ + "static/media/solano_shadow-half.68b4cc88.png";